// ABSOLUTE PATHS

export const STRAPI_URI = process.env.API_URI || 'http://localhost:1337'
export const BLOG_URI = process.env.BLOG_URI || 'https://www.example.com/'
export const DOMAIN = process.env.DOMAIN || 'http://localhost:8000'

// RELATIVE PATHS

export const PATHS = {
  HOME: '/',
  TEST:'/test',
  SAMPLE: '/sample-landing',
  INDEX: '/',
  WORKS: '/works',
  CULTURE: '/our-culture',
  SERVICES: '/services',
  CONTACT: '/contact-us',
  PDF_TREATMENT: '/pdf/TreatmentReferralForm.pdf',
  CAREERS: '/careers',
}

export const SOCIAL = {
  FACEBOOK: 'https://www.facebook.com/lifehomecarenewjersey',
  INSTAGRAM: 'https://www.instagram.com/lifehomecare.nj/',
  LINKEDIN: 'https://www.linkedin.com/company/lifehomecarenewjersey/',
  HOME_CARE: 'https://homecare.life/',
  RIDE: 'https://ride.life/',
  DME: 'http://www.mydme.life/'
}
